<template>
  <ProductSeriesPage
    :title="title"
    :subtitle="subtitle"
    :hero-image="heroImage"
    :items="items"
  />
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import ProductSeriesPage from '@/components/ProductSeriesPage.vue'
import seriesProductImages from './seriesProductImages'

const { t, tm, locale } = useI18n()
const heroImage = require('@/assets/images/pixso-automotive-products/gnss-series-hero.jpg')
const isEnglish = computed(() => locale.value === 'en')

const itemImages = [
  seriesProductImages.gnm12b,
  seriesProductImages.gnm12d,
  seriesProductImages.gnm13,
  seriesProductImages.gnm14,
  seriesProductImages.cx005
]

const itemLinks = [
  '/product/automotive/gnss/gnm12-b',
  '/product/automotive/gnss/gnm12-d',
  '/product/automotive/gnss/gnm13',
  '/product/automotive/gnss/gnm14',
  '/product/automotive/gnss/cx005'
]

const title = computed(() => t('AutomotiveIndex.series.items.gnss.title'))
const subtitle = computed(() => (isEnglish.value ? '' : t('AutomotiveIndex.series.items.gnss.subtitle')))

const items = computed(() => {
  const seriesItems = tm('GNM11.series.items') || []

  return seriesItems.map((item, index) => ({
    title: item.title,
    description: item.description,
    image: itemImages[index],
    to: itemLinks[index]
  }))
})
</script>
